import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

/**
 * .js-horizontalScroll を pin した状態で .js-horizontalScroll-track を
 * 右→左 (translateX) にスクロール量に応じて流す。
 *
 * - 画像の遅延ロードによるレイアウトずれを避けるため、要素が viewport に
 *   入ったタイミングで ScrollTrigger.refresh() を 1 度だけ呼ぶ。
 * - 読み込み時にすでに要素が画面上 or 画面より上にある場合も同様に refresh する。
 */
export default class HorizontalScroll {
  constructor() {
    this.bindLenis();
    this.init();
  }

  init() {
    const items = document.querySelectorAll('.js-horizontalScroll');
    if (!items.length) return;

    items.forEach((el) => {
      const track = el.querySelector('.js-horizontalScroll-track');
      if (!track) return;

      const getDistance = () => Math.max(0, track.scrollWidth - el.clientWidth);

      const tween = gsap.to(track, {
        x: () => -getDistance(),
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top top',
          end: () => `+=${getDistance()}`,
          pin: true,
          scrub: 1,
          invalidateOnRefresh: true,
          anticipatePin: 1
        }
      });

      this.setupLazyRefresh(el, tween);
    });
  }

  setupLazyRefresh(el, tween) {
    let refreshed = false;

    const doRefresh = () => {
      if (refreshed) return;
      refreshed = true;
      const st = tween && tween.scrollTrigger;
      if (st) st.refresh();
    };

    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      // 画面上または画面より上にある → 次フレームで refresh
      requestAnimationFrame(doRefresh);
      return;
    }

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          doRefresh();
          io.disconnect();
        });
      },
      { threshold: 0 }
    );
    io.observe(el);
  }

  bindLenis() {
    // Lenis スクロールと ScrollTrigger を同期。重複バインド防止のガード付き。
    if (window.__lenisScrollTriggerBound) return;
    if (!window.__lenis || typeof window.__lenis.on !== 'function') return;
    window.__lenis.on('scroll', ScrollTrigger.update);
    window.__lenisScrollTriggerBound = true;
  }
}
